import React from 'react'

const Footer = () => (
  <footer className='layout-light'>
    <div className='container sm-ptb-35px padding-tb-50px'>
      <div className='row'>

        <div className='col-lg-4 col-md-6 col-6'>
          <div className='about-us'>
            <div className='logo-footer'>
              <a aria-label='Footer Logo NodeSource' target='blank' href='https://nodesource.com/'>
                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><path d='M89.243 20.864L55.642 1.5a11.21 11.21 0 0 0-11.2 0L10.778 20.937a11.208 11.208 0 0 0-5.6 9.7l-.032 38.781a11.2 11.2 0 0 0 5.611 9.718L44.359 98.5a11.208 11.208 0 0 0 11.2 0l33.663-19.437a11.206 11.206 0 0 0 5.6-9.7l.028-38.784a11.2 11.2 0 0 0-5.607-9.715zM46.36 4.823a7.338 7.338 0 0 1 1.723-.718v16.552a1.917 1.917 0 0 0 3.834 0V4.079a7.369 7.369 0 0 1 1.81.741l33.6 19.366a7.322 7.322 0 0 1 1.522 1.169L68.486 37.113a22.518 22.518 0 0 0-36.983.014L11.186 25.418a7.329 7.329 0 0 1 1.51-1.16zM68.713 50a18.74 18.74 0 0 1-16.8 18.616V51.107l15.149-8.746A18.579 18.579 0 0 1 68.713 50zm-35.785-7.626l15.155 8.734v17.508a18.679 18.679 0 0 1-15.155-26.242zM50 47.786l-15.149-8.729a18.651 18.651 0 0 1 30.288-.012zM12.672 75.813a7.284 7.284 0 0 1-1.522-1.168l13.117-7.574a1.918 1.918 0 0 0-1.918-3.321L9.232 71.323a7.316 7.316 0 0 1-.251-1.9l.029-38.786a7.274 7.274 0 0 1 .254-1.9l20.318 11.71a22.53 22.53 0 0 0 18.5 32.015v22.945a1.9 1.9 0 0 0 .083.53 7.351 7.351 0 0 1-1.892-.757zm40.969 19.364a7.362 7.362 0 0 1-1.8.741 1.919 1.919 0 0 0 .077-.511V72.461A22.533 22.533 0 0 0 70.411 40.43l20.357-11.754a7.329 7.329 0 0 1 .251 1.9l-.028 38.784a7.33 7.33 0 0 1-.264 1.937L77.651 63.75a1.918 1.918 0 0 0-1.918 3.321l13.053 7.536a7.3 7.3 0 0 1-1.481 1.135z' fill='#89a19d' /></svg>
              </a>
            </div>
            <div className='copy-right'>
              <ul className='social-media list-inline'>
                <li className='list-inline-item'><a aria-label='Link Github' className='github' target='blank' href='http://github.com/nodesource'><i className='fa fa-github' aria-hidden='true' /></a></li>
                <li className='list-inline-item'><a aria-label='Link Linkedin' className='linkedin' target='blank' href='https://www.linkedin.com/company/nodesource'><i className='fa fa-linkedin' aria-hidden='true' /></a></li>
                <li className='list-inline-item'><a aria-label='Link Twitter' className='twitter' target='blank' href='https://twitter.com/nodesource'><i className='fa fa-twitter' aria-hidden='true' /></a></li>
              </ul>
              <div className='copy-right-text'>
                © 2020 Powered By NodeSource
              </div>
            </div>
          </div>
        </div>

        <div className='col-lg-4 col-md-6 col-6'>
          <div className='nile-widget widget_nav_menu'>
            <span className='title'>WHAT WE DO</span>
            <ul className='footer-menu'>
              <li><a href='https://nodesource.com/products/nsolid' target='blank'>N|Solid™ On-premise</a></li>
              <li><a href='https://nodesource.com/services' target='blank'>NodeSource Services</a></li>
            </ul>
          </div>
        </div>

        <div className='col-lg-4 col-md-6 col-6'>
          <div className='nile-widget widget_nav_menu'>
            <span className='title'>Company</span>
            <ul className='footer-menu'>
              <li><a href='https://pages.nodesource.com/contact-us.html' target='blank'>Contact</a></li>
              <li><a href='https://nodesource.com/about' target='blank'>About</a></li>
              <li><a href='https://nodesource.com/careers' target='blank'>Careers</a></li>
              <li><a href='https://nodesource.com/legal/privacy' target='blank'>Privacy Policy</a></li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  </footer>
)

export default Footer
